import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  position: relative;
  background-size: cover;
  background-position: center bottom;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-size: 100% 100%;
  background-position: center center;

  animation: gradient 8s ease infinite;

  @keyframes gradient {
    0% {
      background-size: 100% 100%;
    }
    50% {
      background-size: 120% 120%;
    }
    100% {
      background-size: 100% 100%;
    }
  }
`;

export const Image = styled.img`
  height: 90vh;
  position: relative;
  bottom: 10vh;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  z-index: 0;
`;
